"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MON332_CLOSED_CMS_ALERT = exports.MC_BANNER_CLOSED = exports.COVID_REMOTE_SALES_TOOLS_CLOSED = void 0;

var _prefix = function _prefix(key) {
  return "CBX:" + key;
};

var COVID_REMOTE_SALES_TOOLS_CLOSED = _prefix('RemoteSalesToolsClosed');

exports.COVID_REMOTE_SALES_TOOLS_CLOSED = COVID_REMOTE_SALES_TOOLS_CLOSED;

var MC_BANNER_CLOSED = _prefix('MCBannerClosed');

exports.MC_BANNER_CLOSED = MC_BANNER_CLOSED;

var MON332_CLOSED_CMS_ALERT = _prefix('CMSBundleAlertClosed');

exports.MON332_CLOSED_CMS_ALERT = MON332_CLOSED_CMS_ALERT;


//////////////////
// WEBPACK FOOTER
// ./js/constants/LocalStorageKeys.js
// module id = 434
// module chunks = 5 6